"use client";

import type { HTMLAttributes, FC, Ref } from "react";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { mergeClasses } from "@huub-web/utils";

import type { ClassNameProp, RequiredChildrenProp } from "../../props";
import { listContainerStyle, listStyle } from "./List.css";
import { Flex } from "../Flex/Flex";
import { borders } from "../../theme/css/borders.css";
import { Separate } from "../Separate/Separate";
import { Ruler, type RulerProps } from "../Ruler/Ruler";

export type ListProps = HTMLAttributes<HTMLDivElement> &
  RequiredChildrenProp &
  ClassNameProp &
  RecipeVariants<typeof listContainerStyle> & {
    rulerVariant?: RulerProps["variant"];
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement>;
  };

/**
 * A list of items.
 * @todo Check semantics and ARIA
 */
export const List: FC<ListProps> = ({
  className,
  variant = "default",
  size = "l",
  rulerVariant = "default",
  children,
  ref,
  ...props
}) => (
  <Flex
    ref={ref}
    className={mergeClasses(
      listStyle,
      listContainerStyle({ variant, size }),
      variant === "secondary" ? borders.default : undefined,
      className,
    )}
    direction="column"
    {...props}
  >
    {["default", "secondary", "compact"].includes(variant) ? (
      <Separate separator={<Ruler variant={rulerVariant} />}>
        {children}
      </Separate>
    ) : (
      children
    )}
  </Flex>
);
